<template>
  <div class="ag-table-component">
    <div class="toolbar">
      <div class="left">
        <!-- <el-button type="primary" size="mini" @click="clearFilter" plain
          >清空筛选</el-button
        > -->
        <slot name="left"></slot>
      </div>
      <div class="right">
        <slot name="right"></slot>
        <!-- <el-pagination
          v-if="showPagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="curPage"
          :page-sizes="[20, 50, 100, 500, 1000, 2000, 5000, 10000]"
          :page-size.sync="curPageSize"
          :pager-count="5"
          layout="prev, pager, next, sizes, total"
          :total="pageTotalNum"
        >
        </el-pagination> -->
        <el-dropdown trigger="click" @command="handleCommand">
          <el-button
            type="primary"
            size="mini"
            plain
            style="width: 28px; height: 28px; margin-left: 10px"
            icon="el-icon-s-tools"
            circle
          ></el-button>
          <el-dropdown-menu slot="dropdown" ref="mydropd">
            <el-dropdown-item icon="el-icon-s-grid" command="hide"
              >列表设置</el-dropdown-item
            >
            <el-dropdown-item icon="el-icon-s-flag" command="fixed"
              >固定设置</el-dropdown-item
            >
            <!-- <el-dropdown-item icon="el-icon-rank" command="full"
              >全屏展示</el-dropdown-item
            > -->
            <el-dropdown-item icon="el-icon-refresh" command="reset"
              >重置表格</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <ag-grid-vue
      ref="agGridVue"
      class="ag-theme-alpine ag-grid-v-line"
      v-bind="$attrs"
      v-on="$listeners"
      :style="{
        height: autoHeight
          ? '100%'
          : isAgTableFullScreen
          ? '87vh'
          : `calc(100vh - ${dlength})`,
      }"
      :rowHeight="30"
      :headerHeight="30"
      :columnDefs="allColumns"
      :rowData="displayData"
      :defaultColDef="defaultColDef"
      :enableRangeSelection="true"
      rowSelection="multiple"
      :rowGroupPanelShow="showSideBar ? 'always' : 'never'"
      :isRowSelectable="isRowSelectable"
      :aggFuncs="aggFuncs"
      :tooltipInteraction="true"
      :suppressAggFuncInHeader="true"
      :statusBar="statusBar"
      :getRowStyle="mygetRowStyle"
      @grid-ready="onGridReady"
      @first-data-rendered="onFirstDataRendered"
      :rowMultiSelectWithClick="true"
      :suppressRowClickSelection="true"
      :pinnedBottomRowData="pinnedBottomRowData"
      :getContextMenuItems="getContextMenuItems"
      columnMenu="new"
      :localeText="localeText"
      :tooltipShowDelay="0"
      :stopEditingWhenCellsLoseFocus="true"
      @selection-changed="onRowSelected"
      @gridColumnsChanged="gridColumnsChanged"
      @column-moved="handleColumnChanged"
      @column-visible="handleColumnChanged"
      @column-pinned="handleColumnChanged"
      @column-resized="handleColumnChanged"
      @sort-changed="handleColumnChanged"
      @filter-changed="onFilterChanged"
      @newColumnsLoaded="handleColumnValueChanged"
      @cell-clicked="onCellClicked"
      :rowClassRules="rowClassRules"
    >
    </ag-grid-vue>
    <CustomDiaplayVue
      v-if="showCustomDisplay"
      :visible.sync="showCustomDisplay"
      :data="diaplayData"
      @display-change="displayChange"
    ></CustomDiaplayVue>
    <CustomPinned
      v-if="showCustomPinned"
      :visible.sync="showCustomPinned"
      @display-change="displayChange"
      :data="diaplayData"
    ></CustomPinned>
  </div>
</template>

<script>
// :enableCellTextSelection="true"
// :ensureDomOrder="true"
// 导致样式问题
import { AgGridVue } from 'ag-grid-vue'
import 'ag-grid-enterprise'
import AG_GRID_LOCALE_CN from '@/components/AgTable/components/AG_GRID_LOCALE_EN.js'
import CustomInputFilter from '@/components/AgTable/components/CustomInputFilter.vue'
import RangeInputComponent from '@/components/AgTable/components/RangeInputComponent.vue'
import RangeDateComponent from '@/components/AgTable/components/RangeDateComponent.vue'
import SingleDateComponent from '@/components/AgTable/components/SingleDateComponent.vue'
import SelectComponent from '@/components/AgTable/components/SelectComponent.vue'
import MulSelectComponent from '@/components/AgTable/components/MulSelectComponent.vue'
import PaginationComponent from '@/components/AgTable/components/PaginationComponent.vue'
import CustomeTextFilterComponent from '@/components/AgTable/CustomeTextFilterComponent'
import CustomDiaplayVue from '@/components/AgTable/CustomDiaplay.vue'
import CustomPinned from '@/components/AgTable/CustomPinned'
import ClearFilterBtn from '@/components/AgTable/ClearFilterBtn.vue'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import useAgPageSize from '@/hooks/usePageSizeStorage.js'
import { mapGetters } from 'vuex'

dayjs.extend(isBetween)

const NoFilterComponent = {
  name: 'NoFilterComponent',
  render (h) {
    return h(
      'div',
      {
        style: {
          'text-align': 'center'
        }
      },
      ['筛选']
    )
  }
}

const EmptyComponent = {
  name: 'EmptyComponent',
  render (h) {
    return h('div')
  }
}

export default {
  components: {
    AgGridVue,
    CustomDiaplayVue,
    CustomPinned,
    /* eslint-disable */
    NoFilterComponent,
    EmptyComponent,
    ClearFilterBtn,
    CustomeTextFilterComponent,
    CustomInputFilter,
    RangeInputComponent,
    RangeDateComponent,
    SingleDateComponent,
    SelectComponent,
    MulSelectComponent,
    PaginationComponent
    /* eslint-enable */
  },
  props: {
    address: {
      type: String,
      required: true
    },
    dlength: {
      type: String,
      default: '200px'
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: () => [],
      required: true
    },
    data: {
      type: Array,
      default: () => [],
      required: true
    },
    total: {
      type: Object,
      default: () => ({})
    },
    selectTotal: {
      type: Object,
      default: () => ({})
    },
    filterTotal: {
      type: Object,
      default: () => ({})
    },
    allTotal: {
      type: Object,
      default: () => ({})
    },
    pageTotalNum: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 100
    },
    currentPage: {
      type: Number,
      default: 1
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    showSideBar: {
      type: Boolean,
      default: false
    },
    getRowStyle: {
      type: Function,
      default: () => {}
    },
    isRowSelectable: {
      type: Function,
      default: () => true
    }
  },
  watch: {
    data: {
      handler (newData) {
        if (this.gridApi) {
          this.gridApi.refreshCells()
          this.$nextTick(() => {
            this.onRowSelected()
          })
          const filter = this.gridApi.getFilterModel()
          if (Object.keys(filter).length === 0) {
            this.$emit('filter-search', [])
          } else {
            const rowData = []
            this.$nextTick(() => {
              this.gridApi.forEachNodeAfterFilter(node => {
                rowData.push(node.data)
              })
              this.$emit('filter-search', rowData)
            })
          }
        }
      },
      deep: true
    },
    columns: {
      handler (newData) {
        this.allColumns = [
          this.checkBoxColumnDef,
          this.typeIndexColumnDef,
          ...this.columns.map(col => {
            const mycolumn = col

            delete mycolumn.suppressMenu

            // opertype 1:没有搜索和过滤 2:只有过滤 3:有搜索和过滤
            mycolumn.filterParams = {
              ...(col.filterParams || {})
            }
            mycolumn.filterParams.opertype = parseInt(
              col?.filterParams?.opertype || 1
            )

            if (mycolumn?.filterParams?.valueType === 'price') {
              mycolumn.valueGetter = params => {
                if (params.node.rowPinned) return params.data[params.colDef.field]
                if (!params.data) return 0
                const value = params.data[params.colDef.field] || 0
                return parseFloat(value)
              }
              mycolumn.aggFunc = 'sum'
              mycolumn.valueFormatter = params => {
                if (!params.node.rowPinned) {
                  return parseFloat(params.value || '0.00').toLocaleString('zh', {
                    minimumFractionDigits: 2
                  })
                }
                if (params.node.rowPinned === 'bottom') {
                  if (
                    params.value &&
                    !isNaN(parseFloat(params.value)) &&
                    isFinite(params.value)
                  ) {
                    return parseFloat(params.value || '0.00').toLocaleString('zh', {
                      minimumFractionDigits: 2
                    })
                  }
                }
              }

              const functionStyle = mycolumn.cellStyle
              mycolumn.cellStyle = params => {
                const rowStyle = functionStyle ? functionStyle(params) : {}
                return { textAlign: 'right', ...rowStyle }
              }
              mycolumn.comparator = (
                valueA,
                valueB,
                nodeA,
                nodeB,
                isDescending
              ) => {
                const islarge = parseFloat(valueA || 0) > parseFloat(valueB || 0)
                return valueA === valueB ? 0 : islarge ? 1 : -1
              }
            }

            if (mycolumn?.filterParams?.valueType === 'number') {
              mycolumn.valueGetter = params => {
                if (params.node.rowPinned) return params.data[params.colDef.field]
                if (!params.data) return 0
                const value = params.data[params.colDef.field] || 0
                return parseFloat(value)
              }

              mycolumn.aggFunc = 'mysum'
              mycolumn.comparator = (
                valueA,
                valueB,
                nodeA,
                nodeB,
                isDescending
              ) => {
                const islarge = parseFloat(valueA || 0) > parseFloat(valueB || 0)
                return valueA === valueB ? 0 : islarge ? 1 : -1
              }
            }

            mycolumn.useValueFormatterForExport = false
            // mycolumn.headerTooltip = mycolumn.headerTooltip || mycolumn.headerName

            const opertype = mycolumn.filterParams.opertype
            if (opertype === 2) {
              mycolumn.filter = 'agTextColumnFilter'
              mycolumn.floatingFilter = true
              mycolumn.suppressHeaderFilterButton = true
            }

            if (opertype === 3) {
              mycolumn.filter = 'agTextColumnFilter'
              mycolumn.floatingFilter = true
              mycolumn.suppressHeaderFilterButton = true
            }

            // 把组件重置一下
            mycolumn.floatingFilterComponent = 'CustomInputFilter'

            if (mycolumn?.filterParams?.etype === 'multselect') {
              if (opertype === 3) {
                mycolumn.filterParams.textMatcher = () => true
              }
              mycolumn.floatingFilterComponent = 'SelectComponent'
            }

            if (mycolumn?.filterParams?.etype === 'manySelectItems') {
              if (opertype === 3) {
                mycolumn.filterParams.textMatcher = () => true
              }
              if (opertype === 2) {
                mycolumn.filterParams.textMatcher = params => {
                  if (!params.value) return false
                  const selectedList = params.filterText.split(',')
                  return selectedList.includes(params.value)
                }
              }
              mycolumn.floatingFilterComponent = 'MulSelectComponent'
            }

            if (mycolumn?.filterParams?.etype === 'dateRange') {
              if (opertype === 3) {
                mycolumn.filterParams.textMatcher = () => true
              }
              if (opertype === 2) {
                mycolumn.filterParams.textMatcher = params => {
                  if (!params.value) return false
                  const filterText = params.filterText.split(',')
                  return dayjs(params.value).isBetween(
                    filterText[0],
                    filterText[1],
                    'day',
                    '[]'
                  )
                }
              }
              mycolumn.floatingFilterComponent = 'RangeDateComponent'
            }

            if (mycolumn?.filterParams?.etype === 'moneyRange') {
              if (opertype === 3) {
                mycolumn.filterParams.textMatcher = () => true
              }
              mycolumn.floatingFilterComponent = 'RangeInputComponent'
            }

            if (mycolumn?.filterParams?.etype === 'date') {
              mycolumn.floatingFilterComponent = 'SingleDateComponent'
            }

            if (
              !mycolumn.cellRenderer &&
              !mycolumn.cellRendererSelector &&
              !mycolumn.tooltipValueGetter
            ) {
              mycolumn.tooltipField = mycolumn.field
            }

            if (mycolumn.cellRenderer || mycolumn.cellRendererSelector) {
              mycolumn.enableValue = false
              mycolumn.enableRowGroup = false
              mycolumn.enablePivot = false
            }

            return mycolumn
          })
        ]
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['isAgTableFullScreen']),
    displayData () {
      return this.data.map(item => item)
    },
    pinnedBottomRowData () {
      const t1 = Object.keys(this.selectTotal || {}).length !== 0
      const t2 = Object.keys(this.filterTotal || {}).length !== 0
      const t3 = Object.keys(this.total || {}).length !== 0
      const t4 = Object.keys(this.allTotal || {}).length !== 0
      const arr = []
      if (t1) arr.push({ typeIndex: '选中', ...this.selectTotal })
      if (t2) arr.push({ typeIndex: '筛选', ...this.filterTotal })
      if (t3) arr.push({ typeIndex: '合计', ...this.total })
      if (t4) arr.push({ typeIndex: '总计', ...this.allTotal })
      // if (!t1 && !t2) {
      //   return [{ typeIndex: '选中', ...this.selectTotal }, { typeIndex: '合计', ...this.total }]
      // } else if (!t1) {
      //   return [{ typeIndex: '选中', ...this.selectTotal }]
      // } else if (!t2) {
      //   return [{ typeIndex: '合计', ...this.total }]
      // } else return []
      return arr
    },
    curPage: {
      get () {
        return this.currentPage
      },
      set (val) {
        this.$emit('update:currentPage', val)
      }
    },
    curPageSize: {
      get () {
        return this.pageSize
      },
      set (val) {
        this.updateLoacalPageSize(val)
        this.$emit('update:pageSize', val)
      }
    },
    // allTableData () {
    //   return this.data.map((item, index) => {
    //     return {
    //       ...item,
    //       typeIndex: index + 1
    //     }
    //   })
    // },
    // allColumns () {
    //   // const simpeColumns = this.columns.filter(item => (!item.cellRenderer && !item.cellRendererSelector))
    //   // const btnColumns = this.columns.filter(item => (item.cellRenderer || item.cellRendererSelector))
    //   // btnColumns = btnColumns.map(item => {
    //   //   return {
    //   //     field: item.field,
    //   //     headerName: item.headerName,
    //   //     sortable: false,
    //   //     filter: false,
    //   //     cellRenderer: item.cellRenderer,
    //   //     cellRendererParams: item.cellRendererParams,
    //   //     cellRendererSelector: item.cellRendererSelector
    //   //   }
    //   // })
    //   const allColumns = [
    //     this.typeIndexColumnDef,
    //     this.checkBoxColumnDef,
    //     ...this.columns.map(i => {
    //       if (i.cellRenderer || i.cellRendererSelector) {
    //         return i
    //       } else {
    //         return {
    //           ...i,
    //           tooltipField: i.field
    //         }
    //       }
    //     })
    //   ]
    //   return allColumns
    // },
    keyName () {
      const routeName = this.$route.path
      const address = this.address
      const keyName = address ? `${routeName}_${address}` : `${routeName}`
      return keyName
    }
  },
  data () {
    return {
      typeIndexColumnDef: {
        headerName: '序号',
        pinned: 'left',
        field: 'typeIndex',
        sortable: false,
        enableValue: false,
        enableRowGroup: false,
        enablePivot: false,
        width: 50,
        filter: false,
        suppressHeaderFilterButton: true,
        suppressHeaderMenuButton: true,
        cellStyle: {
          textAlign: 'center'
        },
        valueGetter: params => {
          if (params.node.rowPinned) return params.data[params.colDef.field]
          // return params.node.sourceRowIndex + 1
          return params.node.rowIndex + 1
        }
      },
      checkBoxColumnDef: {
        width: 60,
        headerName: '',
        field: 'typeSelectBox',
        checkboxSelection: true,
        pinned: 'left',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        floatingFilterComponent: 'ClearFilterBtn',
        suppressFloatingFilterButton: true,
        floatingFilterComponentParams: {
          enter: this.clearFilter,
          getFilterLength: () => this.filterLength
        },
        sortable: false,
        // filter: false,
        resizable: false,
        suppressMovable: true,
        cellClass: 'cellCenter',
        headerClass: 'headerCellCenter'
        // suppressMenu: true,
      },
      allColumns: [],
      filterLength: 0,
      defaultColDef: {
        // flex: 1,
        resizable: true,
        sortable: true,
        enableValue: true,
        enableRowGroup: true,
        enablePivot: true,
        filter: false,
        floatingFilter: false,
        suppressHeaderMenuButton: true,
        mainMenuItems: [
          'pinSubMenu',
          'columnChooser',
          'separator',
          'autoSizeThis',
          'autoSizeAll',
          'resetColumns',
          'separator',
          {
            name: '清空所有筛选',
            icon: '<span class="ag-icon ag-icon-cross"></span>',
            action: () => {
              this.clearFilter()
            }
          },
          {
            name: '刷新数据',
            action: () => {
              this.handleEnterClick()
            }
          }
        ],
        floatingFilterComponent: 'CustomInputFilter',
        suppressHeaderFilterButton: true,
        suppressFloatingFilterButton: true,
        floatingFilterComponentParams: {
          enter: this.handleEnterClick
        },
        valueGetter: params => {
          if (!params.data) return ''
          const value = params.data[params.colDef.field]
          if (value === null || value === undefined) return ''
          return params.data[params.colDef.field]
        },
        width: 100,
        lockPinned: true
        // editable: true
        // suppressMenu: true
      },
      statusBar: {
        statusPanels: [
          { statusPanel: 'agTotalRowCountComponent', align: 'left' },
          { statusPanel: 'agFilteredRowCountComponent', align: 'left' },
          { statusPanel: 'agSelectedRowCountComponent', align: 'left' },
          { statusPanel: 'agAggregationComponent', align: 'left' },
          {
            statusPanel: 'PaginationComponent',
            align: 'right',
            statusPanelParams: {
              showPagination: () => this.showPagination,
              getTotal: () => this.pageTotalNum,
              pageSize: () => this.pageSize,
              currentPage: () => this.currentPage,
              updatePageSize: val => {
                this.updateLoacalPageSize(val)
                this.$emit('update:pageSize', val)
              },
              updateCurrentPage: val => {
                this.$emit('update:currentPage', val)
              },
              handleSizeChange: val => {
                this.$emit('size-change', val)
              },
              handleCurrentChange: val => {
                this.$emit('current-change', val)
              }
            }
          }
        ]
      },
      aggFuncs: null,
      isSearched: false,
      isFullScreen: false,
      localeText: AG_GRID_LOCALE_CN,
      localPageSize: '',
      gridApi: null,
      gridColumnApi: null,
      showCustomDisplay: false,
      showCustomPinned: false,
      diaplayData: [],
      localStorageKey: 'AG_TABLE_CUSTOM_DISPLAY'
    }
  },
  created () {
    this.rowClassRules = {
      'check-bottom-pinned': params => {
        return params.node.rowPinned && params.data.typeIndex === '选中'
      },
      'total-bottom-pinned': params => {
        return params.node.rowPinned
      }
    }
    this.aggFuncs = {
      mysum: params => {
        const values = params.values || []
        const sum = values.reduce((acc, value) => acc + value, 0)
        return Math.round(sum * 100) / 100
      }
    }
    // if (this.address) {
    //   this.localPageSize = useAgPageSize(this.address)
    // }
  },
  mounted () {
    // this.$refs.dropdownhere.appendChild(
    //   this.$refs.mydropd.popperElm
    // )
    document.addEventListener('fullscreenchange', this.onFullScreenChange)
    document.addEventListener('mozfullscreenchange', this.onFullScreenChange) // Firefox
    document.addEventListener('webkitfullscreenchange', this.onFullScreenChange) // Chrome, Safari and Opera
    document.addEventListener('MSFullscreenChange', this.onFullScreenChange) // IE/Edge
  },
  beforeDestroy () {
    document.removeEventListener('fullscreenchange', this.onFullScreenChange)
    document.removeEventListener('mozfullscreenchange', this.onFullScreenChange) // Firefox
    document.removeEventListener('webkitfullscreenchange', this.onFullScreenChange) // Chrome, Safari and Opera
    document.removeEventListener('MSFullscreenChange', this.onFullScreenChange) // IE/Edge
  },
  activated () {
    this.initData()
  },
  methods: {
    clearFilter () {
      if (this.gridApi) {
        const filter = this.gridApi.getFilterModel()
        const keys = Object.keys(filter)
        const searchFields = this.columns
          .filter(item => item.filterParams && item.filterParams.opertype === 3)
          .map(item => item.field)
        const hasSearchKeys = searchFields.filter(item => {
          return keys.includes(item)
        })
        this.gridApi.setFilterModel(null)
        if (hasSearchKeys && hasSearchKeys.length > 0 && this.isSearched) {
          this.isSearched = false
          this.$emit('filter-enter', [])
        }
      }
    },
    handleEnterClick () {
      const filter = this.gridApi.getFilterModel()
      const params = Object.keys(filter).map(key => {
        return {
          field: key,
          value: filter[key].filter
        }
      })
      this.isSearched = true
      this.$emit('filter-enter', params)
    },
    onRowSelected () {
      const selectedRows = this.gridApi.getSelectedRows()
      this.$emit('select-changed', selectedRows)
    },
    handleColumnMoved (event) {
      if (event.finished) {
        this.saveData()
      }
    },
    handleColumnValueChanged (event) {
      // 为了解决兼容不同tab显示不同字段，所以需要重置column状态
      // 但会带来一个问题，排序的状态不会保留
      // 解决办法，将排序存入storage
      // this.gridColumnApi && this.gridColumnApi.resetColumnState()
      this.gridApi && this.gridApi.resetColumnState()
      this.initData()
    },
    handleSortChanged (e) {
      if (e.source === 'uiColumnSorted' && e.type === 'sortChanged') {
        this.saveData()
      }
    },
    handleColumnVisibled (event) {
      this.saveData()
    },
    handleColumnResized (event) {
      if (event.finished) {
        // 如果是表格自动改变
        if (event.source === 'gridOptionsChanged') {
          this.initData()
        } else {
          this.saveData()
        }
      }
    },
    onFilterChanged (e) {
      const filter = this.gridApi.getFilterModel()
      this.filterLength = Object.keys(filter).length
      if (this.filterLength === 0) {
        this.$emit('filter-search', [])
      } else {
        const rowData = []
        e.api.forEachNodeAfterFilter(node => {
          rowData.push(node.data)
        })
        this.$emit('filter-search', rowData.filter(Boolean))
      }
      if (e.source === 'api') {
        // setStringFilterValue
        const keys = Object.keys(filter)
        const searchFields = this.columns
          .filter(item => item.filterParams && item.filterParams.opertype === 3)
          .map(item => item.field)
        const hasSearchKeys = searchFields.filter(item => {
          return keys.includes(item)
        })
        if (hasSearchKeys && hasSearchKeys.length > 0) {
          this.handleEnterClick()
        }
      }
    },
    onGridReady (params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      this.initData()
    },
    onFirstDataRendered (params) {
      if (this.data.length > 0) {
        // 本地数据
        const customDisplay = JSON.parse(
          window.localStorage.getItem(this.localStorageKey) || '{}'
        )
        const columnLocal =
          (customDisplay[this.keyName] && customDisplay[this.keyName].column) ||
          []
        if (columnLocal.length > 0) {
          return
        }
        // const allColumnIds = params.columnApi.getColumns().map((column) => column.getId())
        const allColumnIds = this.gridApi
          .getColumns()
          .filter(column => !column.userProvidedColDef.width)
          .map(column => column.getId())
        params.api.autoSizeColumns(allColumnIds, false)
      }
    },
    handleSizeChange (val) {
      this.curPage = 1
      this.$emit('size-change', val)
    },
    handleCurrentChange (val) {
      this.$emit('current-change', val)
    },
    handleCommand (command) {
      if (command === 'hide') this.handleShowCustomDisply()
      if (command === 'fixed') this.handleShowCustomPinned()
      if (command === 'full') this.fullScreen()
      if (command === 'reset') this.reset()
    },
    reset () {
      const customDisplay = JSON.parse(
        window.localStorage.getItem(this.localStorageKey) || '{}'
      )
      customDisplay[this.keyName] = {}
      window.localStorage.setItem(
        this.localStorageKey,
        JSON.stringify(customDisplay)
      )
      if (this.gridApi) {
        this.gridApi.resetColumnState()
        const allColumnIds = this.gridApi
          .getColumns()
          .filter(column => !column.userProvidedColDef.width)
          .map(column => column.getId())
        this.gridApi.autoSizeColumns(allColumnIds, false)
      }
      // if (this.gridColumnApi) {
      //   // this.gridColumnApi.resetColumnState()
      //   // this.gridColumnApi && this.gridColumnApi.sizeColumnsToFit()
      //   // const allColumnIds = this.gridColumnApi.getColumns().map((column) => column.getId())
      //   const allColumnIds = this.gridColumnApi
      //     .getColumns()
      //     .filter(column => !column.userProvidedColDef.width)
      //     .map(column => column.getId())
      //   this.gridColumnApi.autoSizeColumns(allColumnIds, false)
      // }
    },
    getDisplayData () {
      const cols = this.gridColumnApi.getAllGridColumns()
      this.diaplayData = cols
        .map(col => {
          return {
            colId: col.colId,
            field: col.colDef.field,
            headerName: col.colDef.headerName,
            actualWidth: col.actualWidth,
            visible: col.visible,
            pinned: col.pinned || null
          }
        })
        .filter(
          item => item.field !== 'typeIndex' && item.field !== 'typeSelectBox'
        )
    },
    handleShowCustomDisply () {
      this.getDisplayData()
      this.showCustomDisplay = true
    },
    handleShowCustomPinned () {
      this.getDisplayData()
      this.showCustomPinned = true
    },
    displayChange (state) {
      this.gridApi.applyColumnState({
        state
      })
      this.getDisplayData()
      this.saveData()
    },
    initData () {
      // 本地数据
      const customDisplay = JSON.parse(
        window.localStorage.getItem(this.localStorageKey) || '{}'
      )
      const columnLocal =
        (customDisplay[this.keyName] && customDisplay[this.keyName].column) ||
        []
      if (columnLocal.length > 0 && this.gridApi) {
        this.gridApi.applyColumnState({
          state: [...columnLocal],
          applyOrder: true
        })
      } else if (
        this.gridApi &&
        this.data.length > 0 &&
        columnLocal.length === 0
      ) {
        // const allColumnIds = params.columnApi.getColumns().map((column) => column.getId())
        const allColumnIds = this.gridApi
          .getColumns()
          .filter(column => !column.userProvidedColDef.width)
          .map(column => column.getId())
        this.gridApi.autoSizeColumns(allColumnIds, false)
      }
    },
    saveData () {
      const allColumnState = this.gridApi.getColumnState()
      const columnList = allColumnState.map(item => {
        console.log(item)
        return {
          colId: item.colId,
          hide: item.hide,
          pinned: item.pinned,
          flex: item.flex,
          width: item.width,
          sort: item.sort,
          sortIndex: item.sortIndex
        }
      })
      const customDisplay = JSON.parse(
        window.localStorage.getItem(this.localStorageKey) || '{}'
      )
      if (!customDisplay[this.keyName]) {
        customDisplay[this.keyName] = {}
      }
      customDisplay[this.keyName].column = columnList
      window.localStorage.setItem(
        this.localStorageKey,
        JSON.stringify(customDisplay)
      )
    },
    fullScreen () {
      // const element = this.$refs.agGridVue.$el
      const element = document.body
      const runfullScreen =
        element.requestFullscreen ||
        element.mozRequestFullScreen ||
        element.webkitRequestFullScreen ||
        element.msRequestFullscreen

      if (runfullScreen) {
        this.$store.dispatch('app/toggleFullScreen', true)
        runfullScreen.call(element)
      } else {
        this.$message.error('当前浏览器不支持全屏！')
      }
    },
    onCellClicked (e) {
      this.$emit('cell-single-click', e)
    },
    exitFullScreen () {
      const runExit =
        document.exitFullscreen ||
        document.mozCancelFullScreen ||
        document.webkitExitFullscreen ||
        document.msExitFullscreen

      if (runExit) {
        this.$store.dispatch('app/toggleFullScreen', false)
        runExit.call(document)
      } else {
        console.error('当前浏览器不支持退出全屏！')
      }
    },
    gridColumnsChanged (e) {
      // console.log(e)
    },
    handleColumnChanged (e) {
      console.log(e)
      if (
        e.source === 'api' ||
        e.source === 'gridOptionsChanged' ||
        e.source === 'flex'
      ) {
        return
      }
      if (e.type === 'columnResized' && !e.finished) return
      if (e.type === 'columnMoved' && !e.finished) return
      if (e.type === 'columnResized') {
        if (e.source !== 'uiColumnResized' && e.source !== 'contextMenu') return
      }
      if (e.type === 'columnVisible') {
        if (e.source !== 'uiColumnMoved' && e.source !== 'contextMenu') return
      }
      if (e.type === 'columnMoved' || e.type === 'columnPinned') {
        if (e.column.colId === 'ag-Grid-AutoColumn') return
      }
      this.saveData()
    },
    getMainMenuItems () {
      return [
        'pinSubMenu',
        'columnChooser',
        'separator',
        {
          name: '表格换行',
          action: () => {
            // setCellWrap()
          }
        },
        // fontBar,
        // spacingBar,
        'separator',
        'autoSizeThis',
        'autoSizeAll',
        'resetColumns',
        'separator',
        {
          name: '清空所有筛选',
          icon: '<span class="ag-icon ag-icon-cross"></span>',
          action: () => {
            // clearFilter()
          }
        },
        {
          name: '刷新数据',
          action: () => {
            // handleEnterClick()
          }
        }
      ]
    },
    getContextMenuItems () {
      if (this.autoHeight) {
        return [
          'copy',
          'copyWithHeaders',
          'separator',
          'autoSizeAll',
          'resetColumns',
          {
            name: '清空所有筛选',
            icon: '<span class="ag-icon ag-icon-cross"></span>',
            action: () => {
              this.clearFilter()
            }
          },
          {
            name: '刷新数据',
            action: () => {
              this.handleEnterClick()
            }
          }
        ]
      } else {
        return [
          'copy',
          'copyWithHeaders',
          'separator',
          'autoSizeAll',
          'resetColumns',
          {
            name: '清空所有筛选',
            icon: '<span class="ag-icon ag-icon-cross"></span>',
            action: () => {
              this.clearFilter()
            }
          },
          {
            name: '刷新数据',
            action: () => {
              this.handleEnterClick()
            }
          },
          'separator',
          {
            name: this.isFullScreen ? '退出全屏' : '全屏展示',
            icon: `<span class="ag-icon ag-icon-${
              this.isFullScreen ? 'minimize' : 'maximize'
            }"></span>`,
            action: () => {
              if (this.isFullScreen) {
                this.exitFullScreen()
              } else {
                this.fullScreen()
              }
            }
          }
        ]
      }
    },
    mygetRowStyle (params) {
      if (!params.data) return
      const rowStyle = this.getRowStyle(params) || {}
      if (params.node.rowPinned === 'bottom') {
        return { 'background-color': '#f6f7fa', ...rowStyle }
      }
      return rowStyle
    },
    onFullScreenChange () {
      this.isFullScreen = !!(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement)
      if (!this.isFullScreen) {
        this.$store.dispatch('app/toggleFullScreen', false)
      }
    },
    updateLoacalPageSize (val) {
      if (this.address) {
        this.localPageSize = useAgPageSize(this.address)
        this.localPageSize.value = val
      }
    },
    setStringFilterValue (prop, value) {
      if (this.gridApi) {
        const filter = this.gridApi.getFilterModel()
        filter[prop] = {
          type: 'contains',
          filter: value
        }
        this.gridApi.setFilterModel(filter)
      }
    }
  }
}
</script>

<style lang="scss">
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-alpine.css";
.ag-theme-alpine {
  --ag-row-height: 30px;
  --ag-cell-horizontal-padding: 7px;
  --ag-font-size: 12px;

  --ag-background-color: #fff;
  --ag-header-background-color: #fff;
  --ag-alpine-active-color: #32b16c;
  --ag-selected-row-background-color: #9fdebc;
  --ag-row-hover-color: #e2efe8;
  --ag-header-column-separator-display: block;
  --ag-border-color: #e4e7ed;
  --ag-header-column-separator-color: #e4e7ed;
  --ag-header-column-resize-handle-display: none;

  // --ag-input-border-color: #32b16c;
  --ag-input-focus-box-shadow: none;
  --ag-checkbox-unchecked-color: #dcdfe6;
  --ag-input-focus-border-color: #32b16c;

  --ag-border-radius: 0;
  --ag-card-radius: 0;

  --ag-header-background-color: #f6f7fb;
  --ag-odd-row-background-color: #f6f7fb;

  .ag-picker-field-wrapper {
    border-radius: 0;
  }

  .ag-unselectable {
    .ag-floating-top,
    .ag-body-viewport,
    .ag-floating-bottom {
      user-select: text;
    }
  }

  .ag-cell-editor {
    .ag-text-field-input {
      border: none;
    }
  }

  .ag-cell-value {
    user-select: none !important; /* Standard syntax */
    -webkit-user-select: none !important; /* Safari */
    -moz-user-select: none !important; /* Old versions of Firefox */
    -ms-user-select: none !important; /* Internet Explorer/Edge */
  }

  .check-bottom-pinned {
    // font-weight: bold;
    background-color: #9fdebc;
  }

  // .total-bottom-pinned {
  //   font-weight: bold;
  // }

  .ag-filter-body .ag-input-field-input.ag-text-field-input {
    background-color: #fff;
    background-image: none;
    // border-radius: 5px;
    // border: 1px solid #dcdfe6;
    // border: none;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 28px;
    line-height: 28px;
    outline: none;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
  }

  .cellCenter {
    .ag-cell-wrapper {
      justify-content: center;

      .ag-selection-checkbox {
        margin-right: 0;
      }
    }
    .ag-cell-value {
      display: none;
    }
  }

  .headerCellCenter {
    justify-content: center;

    .ag-header-select-all {
      margin-right: 0;
    }

    .ag-header-cell-comp-wrapper {
      display: none;
    }
  }
  .ag-header {
    z-index: 10;
  }
  .ag-menu {
    z-index: 11;
  }
  .ag-header-icon,
  .ag-header-label-icon,
  .ag-filter-icon {
    display: none;
  }
  .ag-column-drop {
    height: 36px;
  }
}

.ag-dnd-ghost {
  height: 30px !important;
}

.ag-grid-v-line .ag-cell {
  & > * {
    height: 27px;
    line-height: 27px;
  }
  border-right-color: #e4e7ed !important;

  &.ag-cell-inline-editing {
    border-right-color: #32b16c !important;
  }
  &.ag-cell-range-single-cell {
    border-color: #32b16c !important;
  }
  &.ag-cell-range-selected.ag-cell-range-right {
    border-right-color: #32b16c !important;
  }
}

.ag-status-bar {
  padding-left: 6px;
  padding-right: 12px;
  background-color: #f6f7fa;
  color: #555b62 !important;
  .ag-status-name-value-value {
    font-weight: 500 !important;
    color: #555b62 !important;
  }
}

.ag-header-cell-filtered {
  background-color: #f56c6d !important;
  color: #fff;
}

// .ag-grid-v-line .ag-header-cell {
//   border-right: 1px solid #e4e7ed !important;
// }
</style>

<style lang="scss">
.ag-table-component {
  padding: 5px;
  background-color: #fff;

  .toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
    padding: 5px 0px;
    background-color: #f9f9f9;

    .el-button {
      border-radius: 0 !important;
    }

    .el-input__inner {
      border-radius: 0 !important;
    }

    .el-input {
      border-radius: 0 !important;
    }

    .left,
    .right {
      display: flex;
      align-items: center;
    }

    .left {
      flex: 1;
      min-width: 0;
    }

    // ::v-deep .el-pagination__sizes {
    //   // .el-input {
    //   //   margin: 0;

    //   //   .el-input__inner {
    //   //     // height: 21px;
    //   //     // line-height: 21px;
    //   //     font-size: 12px;
    //   //   }
    //   //   .el-input__icon {
    //   //     line-height: 21px;
    //   //   }
    //   // }
    // }
  }
}
</style>
